import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const msciApi = createApi({
  reducerPath: 'msciApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_CHECKOUT}/installments-core/v1`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['msci'],
  endpoints: (builder) => ({
    getInstallments: builder.query({
      query: (eventId) => `/checkout/installment/${eventId}`,
      providesTags: ['msci'],
      keepUnusedDataFor: 0,
    }),
    getInstallmentsByBin: builder.query({
      query: ({ bin, id }) =>
        `/checkout/installment/bins/${bin}?event_id=${id}`,
      providesTags: ['binInstallment'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetInstallmentsQuery,
  useLazyGetInstallmentsQuery,
  useGetInstallmentsByBinQuery,
  useLazyGetInstallmentsByBinQuery,
} = msciApi;
